import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './styles/marker.scss';
import ToolTip from '@loggi/ui/components/tool-tip';
import View from '@loggi/ui/components/view';

export default function Marker(props) {
  const toolTip = props.tooltip ? <ToolTip label={props.tooltip} /> : null;

  const wrapShapeClasses = classNames([
    { [styles.wrapShape]: !props.isGroup },
    { [styles.wrapGroup]: props.isGroup },
    props.className
  ]);

  const viewBox = props.isGroup ? '0 0 54 54' : '0 0 54 68';

  return (
    <View className={wrapShapeClasses}>
      {toolTip}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        preserveAspectRatio="none"
      >
        <path
          className={styles.shapePin}
          d="M2,26.2c0,0.48.13,2.49,0.15,2.65C3.89,45.53,21.29,61.6,25.89,65.59a1.71,1.71,0,0,0,2.22,
             0c4.6-4,22-20.06,23.74-36.74,0-.16.15-2.16,0.15-2.65C52,12.83,40.81,2,27,2S2,12.83,2,26.2Z"
        />
        <circle className={styles.shapeGroup} cx="27" cy="27" r="25" />
        <circle className={styles.shapeCircle} cx="27" cy="27" r="19" />
        <g transform="translate(27,27)">
          <circle className={styles.shapeCircleLoader} cx="0" cy="0" r="19" />
        </g>
      </svg>
    </View>
  );
}

Marker.displayName = 'Marker';
Marker.propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.string,
  isGroup: PropTypes.bool
};
Marker.defaultProps = {
  className: null,
  tooltip: null,
  isGroup: false
};
